import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import IEditorStructure from '@start-set/wakadoo-editor-core/IEditorStructure';

interface IInitialState {
	editor_structure: IEditorStructure | undefined,
	managerId: number | undefined | null,
	name: string,
	deadline: string | null | undefined,
	preview: string | null,
}

const initialState: IInitialState = {
	editor_structure: undefined,
	deadline: undefined,
	managerId: null,
	name: '',
	preview: null,
};

export const editorSlice = createSlice({
	name: 'editor',
	initialState,
	reducers: {
		setEditorStructure: (state, action: PayloadAction<IEditorStructure>) => {
			state.editor_structure = action.payload;
		},
		setEditorName: (state, action: PayloadAction<string>) => {
			state.name = action.payload;
		},
		setEditorManagerId: (state, action: PayloadAction<number | undefined | null>) => {
			state.managerId = action.payload;
		},
		setEditorDeadline: (state, action: PayloadAction<string | null | undefined>) => {
			state.deadline = action.payload;
		},
		setEditorPreview: (state, action: PayloadAction<string | null>) => {
			state.preview = action.payload;
		},
	},
});

export const {
	setEditorDeadline,
	setEditorManagerId,
	setEditorName,
	setEditorPreview,
	setEditorStructure,
} = editorSlice.actions;

export default editorSlice.reducer;
